export default (store, events) => {
  const { componentId, originalComponentId } = store.getState().site;

  const dispatchToStore = ({ name, data, origin }) => {
    if (data.type) {
      // eslint-disable-next-line no-console
      console.error(
        `Wix event ${name} has property "type" defined in its payload, which is reserved for redux actions. Please use another name.`,
      );
      return;
    }

    // Dispatch only these events:
    // * Coming from parent widget (event origin is Wix.Utils.getOrigCompId())
    // * Coming from child popup with parent component id in event data.compId
    // * Coming from other widgets dispatched to common parent widget
    // * Own events (event origin is Wix.Utils.getCompId())
    const isFromParent = origin === originalComponentId;
    const isOwn = origin === componentId;
    const isFromChild = data.compId === componentId;
    const isFromOtherWidgetToParent = data.compId && data.compId === originalComponentId;

    if (isOwn || isFromParent || isFromChild || isFromOtherWidgetToParent) {
      store.dispatch({ type: name, ...data });
    }
  };

  Object.keys(events).forEach((key) => {
    const event = events[key];
    Wix.PubSub.subscribe(event, dispatchToStore);
  });
};
